import { useState } from "react";
import { IconCheck, IconX } from "@tabler/icons-react";
import { Button } from "@/lib/components/Button/Button";
import { Input } from "@/lib/components/Input";
import { useDfyOrderStore } from "@/lib/stores/dfy-order-store/dfy-order-store";

export default function DfyCouponInput() {
  const coupon = useDfyOrderStore((state) => state.coupon);
  const service = useDfyOrderStore((state) => state.service);

  const [isInputOpen, setIsInputOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const trimmedValue = inputValue.trim();

  const handleApply = async () => {
    if (isLoading) {
      return;
    }

    if (!trimmedValue) {
      setIsInputOpen(false);
      return;
    }

    setIsLoading(true);
    try {
      await service.applyCoupon(trimmedValue);
    } finally {
      setIsLoading(false);
    }
  };

  if (coupon) {
    return (
      <div className="flex items-center gap-2 text-sm text-text-secondary">
        <span>Coupon applied: {coupon.code}</span>
        <Button
          size="iconXs"
          variant="ghost"
          onClick={service.removeCoupon}
          aria-label="Remove coupon"
        >
          <IconX />
        </Button>
      </div>
    );
  }

  if (!isInputOpen) {
    return (
      <p
        className="cursor-pointer text-sm text-text-secondary underline"
        onClick={() => setIsInputOpen(true)}
      >
        Apply coupon
      </p>
    );
  }

  return (
    <form
      className="flex max-w-xs gap-2"
      onSubmit={(e) => {
        e.preventDefault();
        void handleApply();
      }}
    >
      <Input
        containerSize="sm"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Coupon code"
        disabled={isLoading}
      />
      <Button
        type="submit"
        size="iconSm"
        variant="outline"
        isLoading={isLoading}
        disabled={isLoading}
        className="shrink-0 grow-0 basis-auto"
      >
        <IconCheck />
      </Button>
    </form>
  );
}
